import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import likeImage from "../../assets/like.svg";
import unlikeImage from "../../assets/unlike.svg";
import { updateLikes } from "../../features/likes/likesSlice";
import { updateUnlikes } from "../../features/unlikes/unlikesSlice";

export default function LikeUnlike({ video }) {
    const {id, likes, unlikes} = video;
    
    let [likesLocal, setLikesLocal] = useState(likes);
    let [unlikesLocal, setUnlikesLocal] = useState(unlikes);
    
    const {videoDetails} = useSelector( (state) => state.likes);
    

    const dispatch = useDispatch();
   

   const likeHanler = (id) => {
    likesLocal = likesLocal + 1;
    setLikesLocal(likesLocal)
    dispatch(updateLikes({id, likesLocal}));
   }

   const unlikeHandler = (id) => {
    unlikesLocal = unlikesLocal + 1;
    setUnlikesLocal(unlikesLocal);
    dispatch(updateUnlikes({id, unlikesLocal}));
   }


    
    return (
        <div className="flex gap-10 w-48">
            <div className="flex gap-1">
                <div className="shrink-0 cursor-pointer" onClick={() => likeHanler(id)}>
                    <img className="w-5 block" src={likeImage} alt="Like" />
                </div>
                <div className="text-sm leading-[1.7142857] text-slate-600">
                    {likesLocal}
                </div>
            </div>
            <div className="flex gap-1">
                <div className="shrink-0 cursor-pointer" onClick={() => unlikeHandler(id)}>
                    <img className="w-5 block" src={unlikeImage} alt="Unlike" />
                </div>
                <div className="text-sm leading-[1.7142857] text-slate-600">
                   {unlikesLocal}
                </div>
            </div>
        </div>
    );
}
